import { Radio } from 'antd';
import { useMemo } from 'react';
import BackgroundColorPicker from './BackgroundColorPicker';
import IgImgSelector from './IgImgSelector';

const BackgroundSelector = ({
  backgroundMode,
  setBackgroundMode,
  backgroundImgUrl,
  setBackgroundImgUrl,
  backgroundColor,
  setBackgroundColor,
  igId,
}) => {
  const derivedMode = useMemo(
    () =>
      backgroundImgUrl
        ? 'IMAGE'
        : backgroundColor
          ? 'COLOR'
          : 'DEFAULT',
    [backgroundImgUrl, backgroundColor]
  );
  const mode = backgroundMode ?? derivedMode;

  const setMode = (newMode) => {
    setBackgroundMode(newMode);
  };

  return (
    <div className="flex flex-col gap-2">
      <Radio.Group
        value={mode}
        onChange={(e) => setMode(e.target.value)}
        className="flex gap-4"
      >
        <Radio value="DEFAULT">Default</Radio>
        <Radio value="COLOR">Color</Radio>
        <Radio value="IMAGE">Image</Radio>
      </Radio.Group>
      {mode === 'COLOR' && (
        <BackgroundColorPicker value={backgroundColor} onChange={setBackgroundColor} />
      )}
      {mode === 'IMAGE' && (
        <IgImgSelector
          fgPictureUrl={backgroundImgUrl}
          setFgPictureUrl={setBackgroundImgUrl}
          igId={igId}
        />
      )}
    </div>
  );
};

export default BackgroundSelector;
